import { CRM_ORIGIN } from "@/lib/shopApi";

/**
 * Brand assets — visueel identiek aan het CRM.
 * Het wordmark is een transparante (achtergrondloze) variant van
 * crm.nextproduct.nl/nextproduct-wordmark.png en staat in /public,
 * zodat het naadloos over elke achtergrond valt.
 */
export const CRM_WORDMARK = `${process.env.PUBLIC_URL || ""}/nextproduct-wordmark.png`;
export const CRM_HERO_IMAGE = `${CRM_ORIGIN}/login-hero.jpg`;
